import React, { ChangeEvent, useEffect, useRef, useState } from "react";

import "./style.css";
import { useAppDispatch, useAppSelector } from "../../_app";
import { CustomTextField } from "../../components/customFormField";
import { CustomButton } from "../../components/customButton";
import { AuthService } from "../../_service";
import { Notify } from "../../utils";
import { Constant } from "../../config";
import { FaEye, FaEyeSlash, FaShieldAlt, FaUserCheck, FaUserCircle, FaUserEdit, FaUserShield } from "react-icons/fa"; // Import eye icons
import { PiUserCircleLight } from "react-icons/pi";

import { IconContext } from "react-icons";
import { PofileService } from "../../_service/ProfileService";
import { NavigateBack } from "../../components";
import { Heading } from "../appSettings/AppSettingsStyles";
import { updateUserIntialState } from "../../_features";

const UserProfile = () => {
  const user = useAppSelector((state) => state.user);
  const groups = useAppSelector((state) => state.user.groups);
  const dispatch = useAppDispatch();

  console.log("okkkk", user.id);

  const [change, setChange] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [blockNo, setBlockNo] = useState("");
  const [streetName, setStreetName] = useState("");
  const [levelNo, setLevelNo] = useState("");
  const [unitNo, setUnitNo] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [profilePic, setProfilePic] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [imageError, setImageError] = useState('');

  const [password, setPassword] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [passwordError, setPasswordError] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [showPassword, setShowPassword] = useState({
    old_password: false,
    new_password: false,
    confirm_password: false,
  });

  const handlePasswordChange = async () => {
    if (password.old_password === "") {
      setPasswordError((p) => ({ ...p, old_password: "can't be empty" }));
    } else if (password.new_password === "") {
      setPasswordError((p) => ({ ...p, new_password: "can't be empty" }));
    } else if (password.confirm_password === "") {
      setPasswordError((p) => ({ ...p, confirm_password: "can't be empty" }));
    } else if (password.confirm_password !== password.new_password) {
      setPasswordError((p) => ({
        ...p,
        confirm_password: "Confirm password do not match",
      }));
    } else {
      try {
        await AuthService._changePasswordUser(password);
        Notify("Password changed successfully");
        setPassword({
          old_password: "",
          new_password: "",
          confirm_password: "",
        });
        setChange(false);
      } catch (error) {
        Notify(Constant.common.something_went_wrong, 0);
        setPasswordError((p) => ({
          ...p,
          old_password: "Old Password is Wrong",
        }));
      }
    }
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    console.log("file", file);
    setImageError('');

    if (!file) return;

    // Validate file type
    const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
    if (!validTypes.includes(file.type)) {
      Notify('Only JPG, PNG, and GIF files are allowed', 0);
      setImageError('Invalid file format');
      e.target.value = '';
      return;
    }

    // Validate file size (800KB)
    const maxSize = 800 * 1024;
    if (file.size > maxSize) {
      Notify('File size exceeds 800KB limit', 0);
      setImageError('File too large');
      e.target.value = '';
      return;
    }

    setSelectedFile(file);
  };
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const getProfileData = async () => {
    setIsLoading(() => true);
    try {
      const { data } = await PofileService._getProfileData(user.id);
      console.log("data", data.profile_image_url);
      
      setFirstName(data.first_name || "");
      setLastName(data.last_name || "");
      setEmail(data.email?.toLowerCase() || "");
      setPhone(data.phone || "");
      setProfilePic(data.profile_image_url)
      const address = data.address || {};
      setBlockNo(address.block_no || "");
      setStreetName(address.street_name || "");
      setLevelNo(address.level_no || "");
      setUnitNo(address.unit_no || "");
      setPostalCode(address.postal_code || "");
      dispatch(
        updateUserIntialState({
          profile_image: data.profile_image_url,
        })
      );

    } catch (error) {
      Notify("Something went wrong", 0);
    }
    setIsLoading(() => false);
  }

  useEffect(() => {
    getProfileData()
  }, [])

  const handleSave = async () => {
    if (imageError != '') {
      return;
    }
    const payload = new FormData();

    payload.append("first_name", firstName);
    payload.append("last_name", lastName);
    payload.append("email", email);
    payload.append("phone", phone);

    if (selectedFile) {
      payload.append("image", selectedFile);
    }

    payload.append("block_no", blockNo || "");
    payload.append("street_name", streetName || "");
    payload.append("level_no", levelNo || "");
    payload.append("unit_no", unitNo || "");
    payload.append("postal_code", postalCode || "");

    try {
      setIsLoading(true);
      const { status } = await PofileService._editProfileData(user.id, payload);

      if (status >= 200 && status < 300) {
        Notify("User Profile Updated Successfully", 1);
        setSelectedFile(null);
        getProfileData();
      }
    } catch (error) {
      Notify(Constant.common.something_went_wrong, 0);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div style={{

    }}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: 12,
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        padding: '1rem'
      }}>
        {/* Header Section */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #eaeaea',
          paddingBottom: '1rem',
          marginBottom: '1rem'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: "0.5rem"
          }}>
            <NavigateBack />
            <Heading>
              Edit User Profile Settings
            </Heading>
          </div>
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",


          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              color: "#2c3e50",
              fontSize: "0.9rem",
              fontWeight: 500
            }}>
              <span>Roles:</span>
            </div>
            <div style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "0.5rem",
              alignItems: "center"
            }}>
              {user.groups && user.groups.length > 0 ? (
                user.groups.map((group: any) => (
                  <div key={group.id} style={{
                    padding: "0.35rem 0.75rem",
                    backgroundColor: "#e2e6ea",
                    borderRadius: "20px",
                    fontSize: "0.85rem",
                    fontWeight: 500,
                    color: "#495057",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.4rem",
                    border: "1px solid #dee2e6"
                  }}>
                    <FaUserCheck style={{ fontSize: "0.9rem", color: "#5a6268" }} />
                    {group.name}
                  </div>
                ))
              ) : (
                <div style={{
                  padding: "0.35rem 0.75rem",
                  backgroundColor: "#e2e6ea",
                  borderRadius: "20px",
                  fontSize: "0.85rem",
                  fontWeight: 500,
                  color: "#495057",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.4rem"
                }}>
                  <FaUserShield style={{ fontSize: "0.9rem", color: "#5a6268" }} />
                  Super User
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Main Content Container */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 400px',
          gap: '2rem',
          alignItems: 'start'
        }}>
          {/* Left Column - Form Fields */}
          <div>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '1rem',
            }}>
              <CustomTextField
                title="First Name"
                value={firstName}
                onChangeText={setFirstName}
              />
              <CustomTextField
                title="Last Name"
                value={lastName}
                onChangeText={setLastName}
              />
            </div>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '1rem',
            }}>
              {/* <CustomTextField
                disabled
                title="Email Address"
                value={email}
                onChangeText={setEmail}
              /> */}
              <div style={{
                display: "flex",
                paddingTop: "1rem",
                justifyContent: "start",
               
              }}>
                <p style={{ color: "#495057" , width: "46%",
                maxWidth: "250px",}}>Email Address:</p>
                <div style={{
                  textAlign : "left"
                }}>{email}</div>
              </div>

              <CustomTextField
                title="Phone Number"
                value={phone}
                onChangeText={setPhone}
              />
            </div>
            <h3 style={{
              fontWeight: 600,
              color: '#2d3748',
              padding: '1rem 0rem',
              borderBottom: '1px solid #eaeaea',

            }}>
              User Address
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '1.5rem',
            }}>
              <CustomTextField
                title="Block Number"
                value={blockNo}
                onChangeText={setBlockNo}
              />
              <CustomTextField
                title="Street Name"
                value={streetName}
                onChangeText={setStreetName}
              />
            </div>


            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '1rem',
            }}>
              <CustomTextField
                title="Level No"
                value={levelNo}
                onChangeText={setLevelNo}
              />
              <CustomTextField
                title="Unit No"
                value={unitNo}
                onChangeText={setUnitNo}
              />
            </div>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '1.5rem'
            }}>
              <CustomTextField
                title="Postal Code"
                value={postalCode}
                onChangeText={setPostalCode}
              />

            </div>
          </div>

          {/* Right Column - Profile Picture */}
          <div style={{
            position: 'sticky',
            top: '1rem',
            padding: '1rem',
            backgroundColor: '#f8fafc',
            borderRadius: 12,
            textAlign: 'center'
          }}>
            <div style={{
              position: 'relative',
              marginBottom: '1rem'
            }}>
              <button
                onClick={handleButtonClick}
                style={{
                  border: 'none',
                  background: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  position: 'relative',
                  display: 'inline-block'
                }}
              >
                {(profilePic || selectedFile) ? (
                  <img
                    src={selectedFile ? URL.createObjectURL(selectedFile) : profilePic}
                    alt="preview"
                    style={{
                      width: 180,
                      height: 180,
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: `3px solid ${imageError ? '#f56565' : '#e2e8f0'}`,
                      transition: 'all 0.2s ease'
                    }}
                  />
                ) : (
                  <div style={{
                    borderRadius: '50%',
                    backgroundColor: '#e2e8f0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <PiUserCircleLight
                      size={180}
                      color="#94a3b8"
                    />
                  </div>
                )}

                <div style={{
                  position: 'absolute',
                  bottom: 10,
                  right: 10,
                  backgroundColor: '#ffffff',
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}>
                  <FaUserEdit color="#64748b" size={20} />
                </div>
              </button>
              <input
                type="file"
                ref={fileInputRef}
                accept="image/jpeg, image/png, image/gif"
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />
            </div>

            <p style={{
              color: imageError ? 'red' : '#64748b',
              fontSize: '0.875rem',
              margin: '0.5rem 0 1.5rem'
            }}>
              {selectedFile ? selectedFile.name : ""}
              <br />
              {imageError || <>
                Recommended size: 200x200px
                <br />
                JPG, PNG or GIF (MAX. 800KB)
              </>}
            </p>
          </div>
        </div>

        {/* Password Change Section */}
        {change && (
          <div style={{
            marginTop: '2rem',
            padding: '2rem',
            backgroundColor: '#f8fafc',
            borderRadius: 12
          }}>
            <h3 style={{
              fontSize: '1.25rem',
              fontWeight: 600,
              color: '#2d3748',
              margin: '0 0 1.5rem'
            }}>
              Change Password
            </h3>

            {['old_password', 'new_password', 'confirm_password'].map((field, index) => (
              <div key={field} style={{
                position: 'relative',
                marginBottom: index < 2 ? '1rem' : 0
              }}>
                <CustomTextField
                  title={field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                  value={password[field as keyof typeof password]}
                  onChangeText={(text) => setPassword(p => ({ ...p, [field]: text }))}
                  type={showPassword[field as keyof typeof showPassword] ? 'text' : 'password'}
                  error={passwordError[field as keyof typeof passwordError]}
                  onFocus={() => setPasswordError(p => ({ ...p, [field]: '' }))}
                />
                <button
                  onClick={() => setShowPassword(prev => ({ ...prev, [field]: !prev[field as keyof typeof showPassword] }))}
                  style={{
                    position: 'absolute',
                    right: "20%",
                    top: "28%",
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#64748b',
                    zIndex: 10
                  }}
                >
                  {showPassword[field as keyof typeof showPassword] ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            ))}
          </div>
        )}

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '1rem',
          marginTop: '2rem',
          borderTop: '1px solid #eaeaea',
          paddingTop: '1.5rem'
        }}>
          <CustomButton
            title={change ? 'Cancel' : 'Change Password'}
            type={change ? 'secondary' : 'primary'}
            onClick={() => setChange(p => !p)}
          />
          {!change && (
            <CustomButton
              disable={isLoading}
              title="Save Changes"
              onClick={handleSave}

            />
          )}
          {change && (
            <CustomButton
              disable={isLoading}
              title="Update Password"
              onClick={handlePasswordChange}
              styles={{ minWidth: 160 }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
